export default __webpack_public_path__ + "static/media/maslool_header.f25342ba.png";